const s = {
  name: "PhoneAndWatch",
  dimensions: { width: 34, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 34 40.1" style="enable-background:new 0 0 34 40.1;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M16,36.1v-2H8v2H16z"/>
		<path class="st0" d="M12,6.3c0.7,0,1.2-0.6,1.2-1.2S12.7,3.8,12,3.8c-0.7,0-1.2,0.6-1.2,1.2S11.3,6.3,12,6.3z"/>
		<path class="st0" d="M26.2,27.3L22.5,31l-2.7-2.7l1.4-1.4l1.3,1.3l2.3-2.3L26.2,27.3z"/>
		<path class="st0" d="M31,28.1c0,2.7-1.3,5.1-3.3,6.5l-0.8,5.5H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h14c2.8,0,5,2.2,5,5v11.1h2.9
			l0.8,5.5C29.7,23,31,25.4,31,28.1z M2,5v30.1c0,1.7,1.3,3,3,3h13.8l-0.5-3.5c-2-1.5-3.3-3.8-3.3-6.5c0-2.7,1.3-5.1,3.3-6.5
			l0.8-5.5H22V5c0-1.7-1.3-3-3-3H5C3.3,2,2,3.3,2,5z M20.9,38.1h4.3l0.3-2.4c-0.8,0.3-1.6,0.4-2.5,0.4c-0.9,0-1.7-0.1-2.5-0.4
			L20.9,38.1z M25.5,20.5l-0.3-2.4h-4.3l-0.3,2.4c0.8-0.3,1.6-0.4,2.5-0.4C23.9,20.1,24.7,20.2,25.5,20.5z M17,28.1c0,3.3,2.7,6,6,6
			s6-2.7,6-6s-2.7-6-6-6S17,24.8,17,28.1z"/>
		<path class="st0" d="M34,26.1h-2v4h2V26.1z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as PhoneAndWatch
};
